import { render, staticRenderFns } from "./popular.vue?vue&type=template&id=2b74d921&scoped=true&"
import script from "./popular.vue?vue&type=script&lang=js&"
export * from "./popular.vue?vue&type=script&lang=js&"
import style0 from "./popular.vue?vue&type=style&index=0&id=2b74d921&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74d921",
  null
  
)

export default component.exports